module.exports = __webpack_public_path__ + "img/post1.94fbecf3.png";